import { render, staticRenderFns } from "./lockInventory.vue?vue&type=template&id=280999f3"
import script from "./lockInventory.vue?vue&type=script&lang=js"
export * from "./lockInventory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports